import React from "react";
import PropTypes from "prop-types";

const GroupField = ({}) => null;

GroupField.propTypes = {};

export default GroupField;
